import { SPORTSBOOK_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TSportsbookSelector, TEqualityFunction } from '../types';

export const useSportsbookSelector =
    <TSelected>(selector: TSportsbookSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) =>
        useCustomSelector<TSelected, typeof SPORTSBOOK_REDUCER>(SPORTSBOOK_REDUCER, selector, equalityFn);
